import classNames from "classnames";

export const YouCard = ({ className }: { className?: string }) => {
  return (
    <p
      className={classNames(
        "text-info-purple w-fit text-[10px] py-0.5 px-2 bg-light-purple/50 font-bold rounded-[4px]",
        className
      )}
    >
      You
    </p>
  );
};
